export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14730.1d5f1c15.jpg";